import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enum';
import { IUnorderedVerticalListItem, IUnorderedVerticalListProperties, UnorderedVerticalList, createUnorderedVerticalList } from '@vfde-brix/ws10/unordered-vertical-list';
import { decodeHtml } from '@vfde-sails/utils';
import { CmsProductBenefit } from '../interface';

export const mountUnorderedVerticalList = (id: HtmlId) =>
    createComponentById(createUnorderedVerticalList, id, NO_PATTERN_BUSINESS_LOGIC);

/**
 * Get props for benefit list
 *
 * @param benefitList - UnorderedVerticalList brix component
 * @param cmsBenefits - CMS configured benefits
 * @returns The updated list items property
 */
const getBenefitListProps = (
    benefitList: UnorderedVerticalList | null,
    cmsBenefits: CmsProductBenefit[],
): Partial<IUnorderedVerticalListProperties> => {
    if (!benefitList || !cmsBenefits.length) {
        return {
            listUnorderedVerticalListItems: [],
        };
    }

    const props = benefitList.getProperties();

    const getBenefitItem = (benefit: CmsProductBenefit): IUnorderedVerticalListItem => ({
        business: NO_PATTERN_BUSINESS_LOGIC,
        stdHeadline: decodeHtml(benefit.headline),
        txtText: benefit.subline,
        stdIcon: benefit.icon,
        optSize: 'default',
    });

    props.listUnorderedVerticalListItems = cmsBenefits.map(getBenefitItem);

    return props;
};

export const updateVerticalList = (comp : UnorderedVerticalList | null, data: CmsProductBenefit[]) =>
    comp?.update(getBenefitListProps(comp, data));
